import { gql } from '@apollo/client';

export const UPDATE_SESSION = gql`
    mutation patchSession($input: PatchSessionInput!) {
        patchSession(input: $input) {
            id
            companyId
            instructorLedTrainingId
            locales {
                locale
                name
            }
            status
            maxSeats
            timezone
            meetingUrl
            registrationUrl
            registrationOpenAt
            registrationCloseAt
            sessionStartAt
            sessionEndAt
            createdAt
            updatedAt
            canceledAt
            filledSeats
            instructors {
                id
            }
            completionCodes {
                id
            } 
            address {
                id
            } 
        }
    }
`;

export default UPDATE_SESSION;
